import './style.css';
import 'ol/ol.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import {Map, View, Overlay} from 'ol';
import {MapboxVectorLayer} from 'ol-mapbox-style';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector.js';
import OSM from 'ol/source/OSM';
import GeoJSON from 'ol/format/GeoJSON.js';
import StadiaMaps from 'ol/source/StadiaMaps.js';
import RasterSource from 'ol/source/Raster.js';
import VectorSource from 'ol/source/Vector.js';
import Layer from 'ol/layer/WebGLTile.js';
import Source from 'ol/source/ImageTile.js';

import Point from 'ol/geom/Point.js';
import Style from 'ol/style/Style.js';
import Icon from 'ol/style/Icon.js';
import Feature from 'ol/Feature.js';

import FullScreen from 'ol/control/FullScreen.js';
import {defaults as defaultControls} from 'ol/control/defaults.js';
import {fromLonLat, get} from 'ol/proj.js';
import {easeOut} from 'ol/easing.js';

import states from './stateboundaries.json' assert { type: "json" };
//import markers from './markers.json' assert { type: "json" };
import parents from './parents.json' assert { type: "json" };
import categories from './categories.json' assert { type: "json" };
import periods from './periods.json' assert { type: "json" };
//import libraries from './libraries.json' assert { type: "json" };
import videos from './videos.json' assert { type: "json" };

import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { reset } from 'ol/transform';

const halfWidth = 20037508.34;

window.addEventListener("load", function() {
    document.getElementById("spinner").style.display = "none";
    document.getElementById("content").style.display = "block";
});

var layerOptions = [];
layerOptions.push(new MapboxVectorLayer({ styleUrl: './json/alidade_smooth_min.json', }));
layerOptions.push(new TileLayer({ source: new StadiaMaps({ layer: 'alidade_smooth', retina: true })}));
layerOptions.push(new TileLayer({ source: new StadiaMaps({ layer: 'osm_bright', retina: true })}));
layerOptions.push(new TileLayer({ source: new StadiaMaps({ layer: 'stamen_watercolor', retina: true })}));
layerOptions.push(new Layer({ source: new Source({ attributions: 'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer">ArcGIS</a>', url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' + 'World_Topo_Map/MapServer/tile/{z}/{y}/{x}', })}));
layerOptions.push(new Layer({ source: new Source({ attributions: 'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer">ArcGIS</a>', url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' + 'World_Street_Map/MapServer/tile/{z}/{y}/{x}', })}));
layerOptions.push(new Layer({ source: new Source({ attributions: 'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer">ArcGIS</a>', url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' + 'NatGEO_World_Map/MapServer/tile/{z}/{y}/{x}', })}));

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

let layerNum = urlParams.get('m');
if (layerNum == null) layerNum = 5;

const currentLayer = layerNum;

var statesLayer = new VectorLayer({
  background: 'none',
  source: new VectorSource({
    url: './json/US_State_and_Territory_Boundaries.json',
    format: new GeoJSON(),
    wrapX: true,
  }),
  style: {
    'fill-color': 'rgba(255, 255, 255, 0)',
    'stroke-color': '#999999',//rgba(0, 0, 0, 0.4)',
    'stroke-width': 2,
  },
});

const iconSource = new VectorSource();
var iconLayer = new VectorLayer({
    source: iconSource
});


const mapCenter = fromLonLat([-120, 40.5]);
const mapZoom = 3.2;
const featureZoom = 9;

const map = new Map({
  controls: defaultControls().extend([
    new FullScreen({
      source: 'fullscreen',
    }),
  ]),
  target: 'map',
  layers: [ layerOptions[currentLayer], statesLayer, iconLayer ],
  view: new View({
    center: mapCenter,
    zoom: mapZoom,
  })
});

const cats = [];
for (const c of categories) {
  
  const iconStyle = new Style({
    image: new Icon({
        src: './markers/' + c.code + '.png',
        scale: getZoomScale(mapZoom),
        anchor: [0.5, 1],
    }),
  });
  const videoIconStyle = new Style({
    image: new Icon({
        src: './markers/' + c.code + '_vid.png',
        scale: getZoomScale(mapZoom),
        anchor: [0.5, 1],
    }),
  });
  //console.log("marker: " + 'markers/' + c.code + '.png');
  cats[c.code] = { title: c.title, color: c.color, iconStyle: iconStyle, videoIconStyle: videoIconStyle };
}

let libraries = [];
async function loadLibraries() {
  const response = await fetch('./json/libraries.json');
  libraries = await response.json();
  loadMenuLibraries();
  loadMarkers();
}

let markers = [];
async function loadMarkers() {
  const response = await fetch('./json/markers.json');
  markers = await response.json();
  setupMarkers();
}

loadLibraries();

let allMarkers = [];
function setupMarkers()
{
    for (const m of markers) {
    m.type = "event";
    m.style = cats[m.category].iconStyle;
    m.color = cats[m.category].color;
    allMarkers.push(m);
  }

  for (const v of videos) {
    v.type = "video";
    v.style = cats[v.category].videoIconStyle;
    v.color = cats[v.category].color;
    allMarkers.push(v);
  }

  const libraryStyle = new Style({
    image: new Icon({
        src: './markers/library.png',
        scale: getZoomScale(mapZoom),
        anchor: [0.5, 1],
    }),
  });
  for (const l of libraries) {
    l.type = "library";
    l.style = libraryStyle;
    l.category = "library";
    l.subcategories = [];
    allMarkers.push(l);
  }

  allMarkers.sort( compare );
  setupFeatures();
}


let allFeatures = [];
function setupFeatures()
{
  for (const a of allMarkers) {
    //const lng = a.lng > 0 ? a.lng - 360 : a.lng;
    const feature = new Feature({
        geometry: new Point(fromLonLat([a.lng, a.lat])),
        name: a.title,
        category: a.category,
        subcategories: a.subcategories,
        blurb: a.description,
        description: a.description,
        color: a.color,
        link: a.link,
        state: a.state,
        date: a.date,
        period: a.period,
        id: a.id,
        library_id: a.library_id,
        type: a.type,
        style: a.style,
        lat: a.lat,
        lng: a.lng,
        image: a.image,
        imageCredit: a.image_credit,
    });
    allFeatures.push(feature);

    toggleFeature(feature, a.type == "event");
    iconSource.addFeature(feature);
  }
}

const popup = new Overlay({
  element: document.getElementById('popup'),
});
map.addOverlay(popup);
const element = popup.getElement();

let popover = bootstrap.Popover.getInstance(element);

let hoveredFeature = null;
map.on('pointermove', function (event) {

  let currentFeature = null;

  const pixel = map.getEventPixel(event.originalEvent);
  const hit = map.forEachFeatureAtPixel(pixel, function (feature, layer) {
      if (feature.get('id') > 0)
      {
          currentFeature = feature;
          
          return true;
      }
  });


  if (hoveredFeature)
  {
    if (hoveredFeature != currentFeature)
    {
      hoveredFeature = null;
      
      if (popover) 
      {
        popover.dispose();
      }
    }
  }

  if (currentFeature)
  {
    if (hoveredFeature != currentFeature)
    {
      hoveredFeature = currentFeature;
      
      showPopup(currentFeature);

    }
  }

  map.getTargetElement().style.cursor = hit ? 'pointer' : '';
});

function showPopup(currentFeature)
{
  const props = currentFeature.getProperties();

  const coordinates = currentFeature.getGeometry().getCoordinates();//event.coordinate;//currentFeature.getGeometry().getCoordinates();
  var worldWidth = halfWidth * 2; // Approx. 40 million meters for world width
  
  while (coordinates[0] > 0)
  {
    coordinates[0] -= worldWidth;
  }
  
  popup.setPosition(coordinates);

  if (props.type == "event")
  {
    const cat = categories.find(c => c.code === props.category);
    const img = props.image != null && props.image != "" ? './eventImages/' + props.image.replace(/'/g, "\\'") : '';
    showPopover(img, props, cat.title);
  }
  else if (props.type == "library")
  {
    const libImg = props.image != null && props.image != "" ? './libraryImages/' + props.image.replace(/'/g, "\\'") : '';
    showPopover(libImg, props, "Library");
  }

  else if (props.type == "video")
  {
    const cat = categories.find(c => c.code === props.category);
    const imgURL = "https://img.youtube.com/vi/" + getYoutubeCode(props.link) + "/mqdefault.jpg";
    showPopover(imgURL, props, cat.title);
  }
}

function showPopover(img, props, title)
{
  //console.log("curzoom: " + map.getView().getZoom());
  const zoomScale = getZoomScale();

  var imgHTML = '';
  if (img != '')
  {
    imgHTML = '<div id="popoverImg" class="popover-image"></div>';
  }
  popover = new bootstrap.Popover(element, {
    animation: false,
    container: element,
    content: '<div class="popup-content">' + imgHTML + '<div class="popover-name">' + props.name + '</div></div>',
    html: true,
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header-custom ' + props.category + ' s1">' +  title + '</h3><div class="popover-body"></div></div>',
    placement: 'top',
    title: title,
    offset: [0, 130 * zoomScale],
  });
  popover.show();

  const popoverImg = document.getElementById("popoverImg");
  if (img != '')
  {
    popoverImg.style.backgroundImage = "url('" + img + "')";
    popoverImg.style.backgroundSize = "cover";
    popoverImg.style.backgroundPosition = "center center";
    //popoverImg.style.display = "block";
  }
  else
  {
    //popoverImg.style.display = "none";
  }

}

let breadcrumbs = [];

map.on('click', function(event) {
  let currentFeature = null;
  const pixel = map.getEventPixel(event.originalEvent);
  const hit = map.forEachFeatureAtPixel(pixel, function (feature, layer) {
      if (feature.get('id') > 0) {
          currentFeature = feature;
          
          return true;
      }
  });
  
  if (currentFeature != null)
  {
    const id = currentFeature.get('id');
    showHidePanel(true);
    switch (currentFeature.get('type'))
    {
      case "event":
        showCurrentFeature(id);
        break;
      case "video":
        showVideo(id);
        break;
      case "library":
        showLibrary(id);
        break;
    }
  }
});

var curZoom = map.getView().getZoom();
map.on('moveend', function(e) {
  var newZoom = map.getView().getZoom();
  if (curZoom != newZoom) {
    updateIconScale();
    curZoom = newZoom;
  }
});

function getZoomScale()
{
  var scalePerZoom = (0.75 - 0.25) / (15 - 3);
  return map.getView().getZoom() * scalePerZoom + 0.25;
}

function updateIconScale()
{
  for (const f of allFeatures)
  {
    const newScale = getZoomScale();
    f.get('style').getImage().setScale([newScale, newScale]);
    f.changed();
  }
}

function resetMapView()
{
  //map.getView().setCenter(mapCenter);
  //map.getView().setZoom(mapZoom);
  setPosZoomInterval(mapZoom, mapCenter);
}

function setPosZoomInterval(zoom, center)
{
  //const newCenter = fromLonLat([lng, lat]);
  map.getView().animate({
        center: center,
        zoom: zoom,
        duration: 500, // milliseconds
        easing: easeOut // linear easing; can use ol.easing functions
      });
}

var curSelection = "";
var curSection = "";
var curId = 0;

//STATES & TERRITORIES

const stateTable = document.getElementById("stateTable");
for (const s of states) {
  const tr = document.createElement("tr");
  tr.onclick = function() { showState(s.STUSPS); };
  stateTable.appendChild(tr);

  const td = document.createElement("td");
  td.style.backgroundColor = "#FFF0D8";
  td.style.padding = "0.7vmin 20px 0.7vmin 20px";
  td.style.fontSize = "1.6vmin";
  td.className = "state-cell";
  td.textContent = s.NAME;
  tr.appendChild(td);
}

const statesButton = document.getElementById("statesButton");
statesButton.addEventListener('click', showStates);

function showStates()
{
  togglePanel("filters");

  for (const f of allFeatures) {
    toggleFeature(f, f.get('type') == "event");
  }

  if (curSelection != "states") resetMapView();
  curSelection = "states";
}

function showState(stateAbbr) 
{
  curSelection = "state";
  curSection = stateAbbr;

  const offset = 80000;
  const state = states.find(s => s.STUSPS === stateAbbr);
  if (state) {
    const xmin = state.xmin > 0 ? state.xmin - 360 : state.xmin;
    const xmax = state.xmax > 0 ? state.xmax - 360 : state.xmax;
    var stateExt1 = fromLonLat([xmin, state.ymin]);
    var stateExt2 = fromLonLat([xmax, state.ymax]);
    var stateExtent = [stateExt1[0] - offset, stateExt1[1] - offset, stateExt2[0] + offset, stateExt2[1] + offset];

    map.getView().fit(stateExtent, {
      size: map.getSize(),
      maxZoom: 15,
      duration: 500,
      easing: easeOut
    });
    showStateList(state.STUSPS);
  }
}

function showStateList(code)
{
  togglePanel("state");
  const state = states.find(s => s.STUSPS === code);
  if (state)
  {
    const stateTitle = document.getElementById("stateTitle");

    const stateImage = document.getElementById("stateImage");
    stateImage.innerHTML = !state.img ? '<img src="./images/Science-across-America.png" class="science-logo" />' : '<img src="./images/states/' + state.img + '" style="max-height:400px;"/>';

    stateTitle.innerHTML = state.NAME;

    const stateList = document.getElementById("stateList");
    stateList.innerHTML = "";

    var shownPeriods = [];
    for (const p of periods)
    {
      const checkbox = document.getElementById("ch-" + p.code);
      if (checkbox.checked)
      {
        shownPeriods.push(p.code);
      }
    }

    for (const f of allFeatures)
    {
      toggleFeature(f, f.get('state') == code);// && shownPeriods.includes(f.get('period')));
    
      //console.log("code: " + code + ", m.category: " + m.category);
      if (f.get('state') != code) continue;// || !shownPeriods.includes(f.get('period'))) continue;
      //console.log("nothing?");
      const tr = document.createElement("tr");

      //tr.onclick = function() { showCategory(c.code) };
      stateList.appendChild(tr);

      const td = document.createElement("td");
      td.style.backgroundColor = "#FFF0D8";
      td.style.padding = "8px 20px 8px 20px";
      td.className = "event-cell";
      
      let icon = "";
      
      const c = categories.find(s => s.code === f.get('category'));
      if (f.get('type') == "event")
      {
        icon = c.code + "_cat.png";
        tr.onclick = function() { showCurrentFeature(f.get('id'), "state") };
      }
      else if (f.get('type') == "video")
      {
        icon = c.code + "_vid_cat.png";
        tr.onclick = function() { showVideo(f.get('id')) };
      }
      else if (f.get('type') == "library")
      {
        icon = "library_cat.png";
        tr.onclick = function() { showLibrary(f.get('id')) };
      }

      tr.onmouseenter = function() {
          showPopup(f);
      };
      tr.onmouseleave = function() {
        if (popover) 
        {
          popover.dispose();
        }
      };

      
      //td.innerHTML = "<img src=\"./markers/" + icon + "\" style=\"display:inline-block; padding-right:5px; height:20px;\"> " + f.get('name');
      td.innerHTML = "<div style=\"display:flex\"><div><img src=\"./markers/" + icon + "\" style=\"height:2.2vmin;\"></div><div style=\"flex: 1;font-size:1.6vmin; padding-left:10px; \">" + f.get('name') + "</div></div>";
      
      tr.appendChild(td);
    }
  }
}

const stateBack = document.getElementById("stateBack");
stateBack.addEventListener('click', showStates);

//END STATES & TERRITORIES



//SCIENCE CATEGORIES

const filterCategories = document.getElementById("filter-categories");

let activeCategories = new Set();
for (const p of parents) {
  
  if (p.code != "other")
  {
    const div = document.createElement("div");
    filterCategories.appendChild(div);

    div.style.padding = "0.7vmin 20px 0.7vmin 20px";

    div.innerHTML = '<div class="s1" style="font-size: 2.8vmin; line-height: 2.8vmin; text-transform: uppercase; color: #8F1833;">' + p.title + '</div>';
    
  }

  const categoryTable = document.createElement("table");
  categoryTable.className = "table table-hover";
  filterCategories.appendChild(categoryTable);

  const categoryTableBody = document.createElement("tbody");
  categoryTable.appendChild(categoryTableBody);

  for (const c of categories) {
    if (c.code === "undefined") continue;
    if (p.code == c.parent || (p.code == "other" && c.parent == ""))
    {
      var lPad = p.code != "other" ? "40px" : "20px";

      activeCategories.add(c.code);
      const tr = document.createElement("tr");
      //tr.onclick = function() { toggleCategory(c.code) };
      tr.onclick = function() { showCategory(c.code) };
      categoryTableBody.appendChild(tr);

      const td = document.createElement("td");
      td.style.backgroundColor = "#FFF0D8";
      td.style.padding = "0.7vmin 20px 0.7vmin " + lPad;
      //td.style.padding = "8px 20px 8px 40px";
      td.className = "category-cell";
      td.id = "cat-" + c.code;
      td.innerHTML = "<div style=\"display:flex\"><div><img src=\"./markers/" + c.code + "_cat.png\" style=\"height:2.2vmin;\"></div><div style=\"flex: 1;font-size:1.6vmin; padding-left:10px; \">" + c.title + "</div></div>";
      tr.appendChild(td);
    }
  }
}

const categoriesButton = document.getElementById("categoriesButton");
categoriesButton.addEventListener('click', showCategories);

function showCategories()
{
  togglePanel("filters");
  
  for (const f of allFeatures) {
    toggleFeature(f, f.get('type') == "event");
  }

  if (curSelection != "categories") resetMapView();
  curSelection = "categories";
}

function showCategory(code)
{
  togglePanel("category");
  curSelection = "category";

  const cat = categories.find(s => s.code === code);
  if (cat)
  {
    const catTitle = document.getElementById("categoryTitle");
    catTitle.style.backgroundColor = "#" + cat.color;

    //catTitle.innerHTML = "<img src=\"./markers/" + cat.code + "_cat.png\" style=\"display:inline-block; padding-right:5px; height:40px;\"> " + cat.title;
    catTitle.innerHTML = "<div style=\"display:flex\"><div><img src=\"./markers/" + cat.code + "_cat.png\" style=\"height:3vmin;\"></div><div style=\"flex: 1;font-size:2.8vmin; line-height:3vmin; padding-left:10px; \">" + cat.title + "</div></div>";
  
    const catList = document.getElementById("categoryList");
    catList.innerHTML = "";

    //console.log("cats?: " + cats);
    
    var shownPeriods = [];
    for (const p of periods)
    {
      const checkbox = document.getElementById("ch-" + p.code);
      if (checkbox.checked)
      {
        shownPeriods.push(p.code);
      }
    }

    for (const f of allFeatures) {
      toggleFeature(f, (f.get('category') == cat.code || f.get('subcategories').includes(cat.code)) && shownPeriods.includes(f.get('period')));
      
      //console.log("code: " + code + ", m.category: " + m.category);
      if (f.get('category') !== code && !f.get('subcategories').includes(code) || !shownPeriods.includes(f.get('period'))) continue;
      const tr = document.createElement("tr");
      tr.onclick = function() { showCurrentFeature(f.get('id'), "category") };
      tr.onmouseenter = function() {
        showPopup(f);
      };
      tr.onmouseleave = function() {
        if (popover) 
        {
          popover.dispose();
        }
      };
      //tr.onclick = function() { showCategory(c.code) };
      catList.appendChild(tr);

      const td = document.createElement("td");
      td.style.backgroundColor = "#FFF0D8";
      td.style.padding = "0.7vmin 20px 0.7vmin 20px";
      td.style.fontSize = "1.6vmin";
      td.className = "event-cell";
      
      //td.id = "cat-" + m.code;
      td.innerHTML = f.get('name') + " | " + f.get('state');
      tr.appendChild(td);
    }
  }
}

const categoryBack = document.getElementById("categoryBack");
categoryBack.addEventListener('click', showCategories);

//END SCIENCE CATEGORIES

//TIME PERIODS

const periodsButton = document.getElementById("periodsButton");
periodsButton.addEventListener('click', showPeriods);

function showPeriods(event)
{
  togglePanel("filters");
  
  var shownPeriods = [];
  for (const p of periods)
  {
    const checkbox = document.getElementById("ch-" + p.code);
    if (checkbox.checked)
    {
      shownPeriods.push(p.code);
    }
  }

  for (const f of allFeatures) {
    toggleFeature(f, f.get('type') == "event" && shownPeriods.includes(f.get('period')));
  }

  if (curSelection != "periods") resetMapView();
  curSelection = "periods";
}

const filterPeriods = document.getElementById("filter-periods");
const periodTable = document.createElement("table");
periodTable.className = "table table-hover";
filterPeriods.appendChild(periodTable);

const periodTableBody = document.createElement("tbody");
periodTable.appendChild(periodTableBody);

for (const p of periods) 
{
  const tr = document.createElement("tr");
  tr.onclick = function() { togglePeriod(p.code); };
  periodTableBody.appendChild(tr);

  const td = document.createElement("td");
  td.style.backgroundColor = "#FFF0D8";
  td.style.padding = "0.7vmin 20px 0.7vmin 20px";
  td.className = "category-cell";
  td.id = "p-" + p.code;

  td.innerHTML = '<div style="display: flex;"><div><input class="form-check-input checkbox-readonly" type="checkbox" value="" id="ch-' + p.code + '" style="margin-right: 10px;" checked></div><div style="flex: 1; font-size: 1.6vmin;">' + p.title + '<br><span style="font-size: 1.5vmin; color: #444;">' + p.time + '</span></div></div>';
  tr.appendChild(td);
}

const selectDiv = document.createElement("div");
selectDiv.className = "period-button";
selectDiv.style.padding = "0px 20px 8px 20px";
selectDiv.style.fontSize = "1.5vmin";
selectDiv.style.width = "100%";
selectDiv.style.textAlign = "center";
//selectDiv.style.hr = "#6A233F";
//selectDiv.innerHTML = '<div class="row"><div class="col-md-12 col-xl-6"><a href="#" id="selectAllPeriods">[SELECT ALL]</a></div><div class="col-md-12 col-xl-6"><a href="#" id="deselectAllPeriods">[DESELECT ALL]</a></div>';
selectDiv.innerHTML = '<a href="#" id="selectAllPeriods"><span style="white-space: pre">[ SELECT ALL ]</span></a> <a href="#" id="deselectAllPeriods"><span style="white-space: pre">[ DESELECT ALL ]</span></a>';

filterPeriods.appendChild(selectDiv);

function togglePeriod(code)
{
  //console.log("toggle period: " + code);
  const checkbox = document.getElementById("ch-" + code);
  const isChecked = !checkbox.checked;
  checkbox.checked = isChecked;

  for (const f of allFeatures)
  {
    if (f.get('period') == code)
    {
      toggleFeature(f, isChecked);
    }
  }
}

const selectAllPeriodsLink = document.getElementById("selectAllPeriods");
selectAllPeriodsLink.addEventListener('click', selectAllPeriods);

const deselectAllPeriodsLink = document.getElementById("deselectAllPeriods");
deselectAllPeriodsLink.addEventListener('click', deselectAllPeriods);

function selectAllPeriods()
{
  toggleAllPeriods(true);
}

function deselectAllPeriods()
{
  toggleAllPeriods(false);
}

function toggleAllPeriods(value)
{
  for (const p of periods)
  {
    const checkbox = document.getElementById("ch-" + p.code);
    checkbox.checked = value;
  }

  for (const f of allFeatures)
  {
    if (f.get('period') != null)
    {
      toggleFeature(f, value);
    }
  }
}

//END TIME PERIODS

//SCIENCE VIDEOS

const videosButton = document.getElementById("videosButton");
videosButton.addEventListener('click', showVideos);

const filterVideos = document.getElementById("filter-videos");
const videoTable = document.createElement("table");
videoTable.className = "table table-hover";
filterVideos.appendChild(videoTable);

const videoTableBody = document.createElement("tbody");
videoTable.appendChild(videoTableBody);

for (const v of videos) 
{
  const tr = document.createElement("tr");
  tr.onclick = function() { showVideo(v.id); };
  tr.onmouseenter = function() {
    for (const f of allFeatures)
    {
      if (f.get('type') == "video" && f.get('id') == v.id)
      {
        showPopup(f);
        break;
      }
    }
  };
  tr.onmouseleave = function() {
    if (popover) 
    {
      popover.dispose();
    }
  };
  videoTableBody.appendChild(tr);

  const td = document.createElement("td");
  td.style.backgroundColor = "#FFF0D8";
  td.style.padding = "0.7vmin 20px 0.7vmin 20px";
  td.className = "category-cell";
  td.id = "vid-" + v.id;
  const c = categories.find(s => s.code === v.category);
  //td.innerHTML = "<img src=\"./markers/" + c.code + "_cat.png\" style=\"display:inline-block; padding-right:5px; height:20px;\"> " + v.title + " | " + v.state;
  td.innerHTML = "<div style=\"display:flex\"><div><img src=\"./markers/" + c.code + "_cat.png\" style=\"height:2.2vmin;\"></div><div style=\"flex: 1;font-size:1.6vmin; padding-left:10px; \">" + v.title + " | " + v.state + "</div></div>";
      
  tr.appendChild(td);
}

function showVideos()
{
  togglePanel("filters");
  
  for (const f of allFeatures)
  {
    toggleFeature(f, f.get('type') == "video");
  }

  if (curSelection != "videos") resetMapView();
  curSelection = "videos";
}

function showVideo(id) 
{
  if (id == null || id == "" || id == 0) return;

  const currentVideo = videos.find(v => v.id == id);
  togglePanel("video");

  const view = map.getView();

  var zoom = view.getZoom();
  if (zoom < featureZoom) {
    zoom = featureZoom;
  }
  setPosZoomInterval(zoom, fromLonLat([currentVideo.lng, currentVideo.lat]));

  const videoTitle = document.getElementById("videoTitle");
  videoTitle.textContent = currentVideo.title;

  const videoImage = document.getElementById("videoImage");

  videoImage.src = "https://img.youtube.com/vi/" + getYoutubeCode(currentVideo.link) + "/maxresdefault.jpg";

  const videoCategory = document.getElementById("videoCategory");
  const videoData = document.getElementById("videoData");
  const videoLink = document.getElementById("videoLink");
  const watchVideoLink = document.getElementById("watchVideoLink");
  const watchVideoStyle = document.getElementById("watchVideoStyle");

  const state = states.find(s => s.STUSPS === currentVideo.state);
  videoData.innerHTML = "<p>" + state.NAME + " | " + currentVideo.date + "</p>";

  var backText = "";
  switch (curSelection)
  {
    case "state":
      backText = "RESULTS";
      break;
    default:
      backText = "FILTERS";
      break;
  }
  videoBack.innerHTML = "&lt; &nbsp;BACK TO " + backText;

  var catOutput = "";
  for (const c of categories) {
    if (c.code === currentVideo.category) {

      videoTitle.style.backgroundColor = "#" + c.color;
      //videoCategory.innerHTML = "<img src=\"./markers/" + c.code + "_cat.png\" style=\"display:inline-block; padding-right:5px; height:20px;\"> " + c.title;
      catOutput += "<div style=\"display:flex\"><div><img src=\"./markers/" + c.code + "_cat.png\" style=\"height:2.2vmin;\"></div><div style=\"flex: 1;font-size:1.6vmin; padding-left:10px; \">" + c.title + "</div></div>";
  
      videoData.style.color = '#' + c.color;

      watchVideoStyle.innerHTML = ".st0 { fill: #" + c.color + "; } .st1 { isolation: isolate; } .st2 { fill: #fff2da; }";//.cls-1{isolation:isolate;}.cls-2{fill:#" + c.color + ";}.cls-3{fill:#fff2da;}";
      watchVideoLink.href = currentVideo.link;
      
      break;
    }
  }
  for (const c of categories) {
    if (currentVideo.subcategories.includes(c.code))
    {
      //catOutput += "<div style=\"margin-top: 5px\"><img src=\"./markers/" + c.code + "_cat.png\" style=\"display:inline-block; padding-right:5px; height:20px;\"> " + c.title + "</div>";
      catOutput += "<div style=\"margin-top: 0.7vmin; display:flex\"><div><img src=\"./markers/" + c.code + "_cat.png\" style=\"height:2.2vmin;\"></div><div style=\"flex: 1;font-size:1.4vmin; padding-left:10px; \">" + c.title + "</div></div>";
  
    }
  }
  videoCategory.innerHTML = catOutput;

  const videoText = document.getElementById("videoText");
  videoText.innerHTML = "<p style=\"font-size: 1.7vmin\">" + currentVideo.description + "</p>";

}

const videoBack = document.getElementById("videoBack");
videoBack.addEventListener('click', parseBackFromEvent);

//END SCIENCE VIDEOS


//PARTICIPATING LIBRARIES
function loadMenuLibraries()
{
  const filterLibraries = document.getElementById("filter-libraries");
  const libraryTable = document.createElement("table");
  libraryTable.className = "table table-hover";
  filterLibraries.appendChild(libraryTable);

  const libraryTableBody = document.createElement("tbody");
  libraryTable.appendChild(libraryTableBody);

  for (const l of libraries) 
  {
    const tr = document.createElement("tr");
    tr.onclick = function() { showLibrary(l.id); };
    tr.onmouseenter = function() {
      for (const f of allFeatures)
      {
        if (f.get('type') == "library" && f.get('id') == l.id)
        {
          showPopup(f);
          break;
        }
      }
      //console.log("enter mouse: " + l.id);
    };
    tr.onmouseleave = function() {
      if (popover) 
      {
        popover.dispose();
      }
    };

    libraryTableBody.appendChild(tr);

    const td = document.createElement("td");
    td.style.backgroundColor = "#FFF0D8";
    td.style.padding = "0.7vmin 20px 0.7vmin 20px";
    td.style.fontSize = "1.6vmin";
    td.className = "category-cell";
    td.id = "lib-" + l.id;
    td.innerHTML = l.title + " | " + l.state;
    tr.appendChild(td);
  }

  const librariesButton = document.getElementById("librariesButton");
  librariesButton.addEventListener('click', showLibraries);
}

function showLibraries()
{
  togglePanel("filters");
  
  for (const f of allFeatures)
  {
    toggleFeature(f, f.get('type') == "library");
  }

  if (curSelection != "libraries") resetMapView();
  curSelection = "libraries";
}

function showLibrary(id)
{
  curSelection = curSelection == "state" || curSelection == "statelibrary" ? "statelibrary" : "library";

  if (id == null || id == "" || id == 0) return;

  curId = id;

  const currentLibrary = libraries.find(v => v.id == id);
  togglePanel("library");

  const libraryImage = document.getElementById("libraryImage");
  libraryImage.innerHTML = !currentLibrary.image ? '<img src="./images/Science-across-America.png" class="science-logo" />' : '<div style="background-color: #333;"><img src="./libraryImages/' + currentLibrary.image + '" style="max-height:400px;"/></div>';

  const view = map.getView();

  let curFeature = null;
  for (const f of allFeatures)
  {
    if (f.get('type') == "library" && f.get('id') == currentLibrary.id)
    {
      curFeature = f;
      break;
    }
  }

  var curCoords = curFeature.getGeometry().getCoordinates();
  if (curCoords[0] > 0) curCoords[0] -= halfWidth * 2;

  var zoom = view.getZoom();
  if (zoom < featureZoom) {
    zoom = featureZoom;
  }
  setPosZoomInterval(zoom, curCoords);//fromLonLat([currentLibrary.lng, currentLibrary.lat]));

  const libraryTitle = document.getElementById("libraryTitle");
  libraryTitle.innerHTML = currentLibrary.title;
  const libraryEventList = document.getElementById("libraryEventList");
  libraryEventList.innerHTML = "";

  const libraryText = document.getElementById("libraryText");
  let addressText = currentLibrary.address;
  if (currentLibrary.address2 != null && currentLibrary.address2 != "") addressText += "<br>" + currentLibrary.address2;
  if (currentLibrary.city != null && currentLibrary.city != "") addressText += "<br>" + currentLibrary.city;
  if (currentLibrary.state != null && currentLibrary.state != "") addressText += ", " + currentLibrary.state;
  if (currentLibrary.zip != null && currentLibrary.zip != "") addressText += " " + currentLibrary.zip;
  libraryText.innerHTML = addressText;

  for (const f of allFeatures)
  {
    if (f.get('type') == "library")
    {
      toggleFeature(f, f.get('id') == currentLibrary.id);
      continue;
    }
    if (f.get('type') == "video")
    {
      toggleFeature(f, false);
      continue;
    }
    if (f.get('type') == "event") 
    {
      toggleFeature(f, f.get('library_id') == currentLibrary.id);
      if (f.get('library_id') == currentLibrary.id)
      {
        const m = markers.find(m => m.library_id == currentLibrary.id && m.id == f.get('id'));
    
        if (m)
        {
          const tr = document.createElement("tr");
          tr.onclick = function() { showCurrentFeature(m.id, "library") };
          tr.onmouseenter = function() {
            for (const f of allFeatures)
            {
              if (f.get('type') == "event" && f.get('id') == m.id)
              {
                showPopup(f);
                break;
              }
            }
          };
          tr.onmouseleave = function() {
            if (popover) 
            {
              popover.dispose();
            }
          };
          //tr.onclick = function() { showCategory(c.code) };
          libraryEventList.appendChild(tr);

          const td = document.createElement("td");
          td.style.backgroundColor = "#FFF0D8";
          td.style.padding = "0.7vmin 20px 0.7vmin 20px";
          td.className = "event-cell";
          //td.id = "cat-" + m.code;
          //console.log("code: " + currentLibrary.code + ", m.category: " + m.category);
          const c = categories.find(s => s.code === m.category);
          td.innerHTML = "<div style=\"display:flex\"><div><img src=\"./markers/" + c.code + "_cat.png\" style=\"height:2.2vmin;\"></div><div style=\"flex: 1;font-size:1.6vmin; padding-left:10px; \">" + m.title + "</div></div>";
        
          //td.innerHTML = "<img src=\"./markers/" + c.code + "_cat.png\" style=\"display:inline-block; padding-right:5px; height:20px;\"> " + m.title;
          tr.appendChild(td);
        }
      }
    }
  }

  /*for (const le of currentLibrary.events) 
  {
    const m = markers.find(m => m.id == le);
    
    if (m)
    {
      const tr = document.createElement("tr");
      tr.onclick = function() { showCurrentFeature(m.id, "library") };
      tr.onmouseenter = function() {
        for (const f of allFeatures)
        {
          if (f.get('type') == "event" && f.get('id') == m.id)
          {
            showPopup(f);
            break;
          }
        }
      };
      tr.onmouseleave = function() {
        if (popover) 
        {
          popover.dispose();
        }
      };
      //tr.onclick = function() { showCategory(c.code) };
      libraryEventList.appendChild(tr);

      const td = document.createElement("td");
      td.style.backgroundColor = "#FFF0D8";
      td.style.padding = "0.7vmin 20px 0.7vmin 20px";
      td.className = "event-cell";
      //td.id = "cat-" + m.code;
      //console.log("code: " + currentLibrary.code + ", m.category: " + m.category);
      const c = categories.find(s => s.code === m.category);
      td.innerHTML = "<div style=\"display:flex\"><div><img src=\"./markers/" + c.code + "_cat.png\" style=\"height:2.2vmin;\"></div><div style=\"flex: 1;font-size:1.6vmin; padding-left:10px; \">" + m.title + "</div></div>";
    
      //td.innerHTML = "<img src=\"./markers/" + c.code + "_cat.png\" style=\"display:inline-block; padding-right:5px; height:20px;\"> " + m.title;
      tr.appendChild(td);
    }
  }*/

  var backText = "";
  switch (curSelection)
  {
    case "statelibrary":
      backText = "RESULTS";
      break;
    default:
      backText = "FILTERS";
      break;
  }
  document.getElementById("libraryBack").innerHTML = "&lt; &nbsp;BACK TO " + backText;
}

const libararyBack = document.getElementById("libraryBack");
libararyBack.addEventListener('click', parseBackFromLibrary);

function parseBackFromLibrary()
{
  var toPanel = "filters";
  console.log("back from library, curselection: " + curSelection);
  switch (curSelection)
  {
    case "statelibrary":
      toPanel = "state";
      showState(curSection);
      break;
    case "library":
    default:
      toPanel = "filters";
      resetMapView();
      for (const f of allFeatures) {
        toggleFeature(f, f.get('type') == "library");
      }
      break;
  }

  //console.log("toPanel: " + toPanel);
  togglePanel(toPanel);
}
//libararyBack.addEventListener('click', showLibraries);
//END PARTICIPATING LIBRARIES




const backFromEvent = document.getElementById("backFromEvent");
backFromEvent.addEventListener('click', parseBackFromEvent);

function showCurrentFeature(id) 
{
  if (id == null || id == "" || id == 0) return;

  const currentFeature = allFeatures.find(f => f.get('id') == id && f.get('type') == "event");
  
  togglePanel("info");

  const view = map.getView();

  var curCoords = currentFeature.getGeometry().getCoordinates();
  if (curCoords[0] > 0) curCoords[0] -= halfWidth * 2;

  //view.setCenter(curCoords);
  var zoom = view.getZoom();
  if (zoom < featureZoom) {
    zoom = featureZoom;
  }
  setPosZoomInterval(zoom, curCoords);

  const featureTitle = document.getElementById("featureTitle");
  featureTitle.textContent = currentFeature.get('name');

  const featureCategory = document.getElementById("featureCategory");
  const featureData = document.getElementById("featureData");
  const featureLearnMoreStyle = document.getElementById("learnMoreStyle");
  const learnMore = document.getElementById("learnMore");
  const learnMoreLink = document.getElementById("learnMoreLink");

  const featureImage = document.getElementById("featureImage");
  if (currentFeature.get('image') != "")
  {
    featureImage.src = "eventImages/" + currentFeature.get('image');
    featureImage.style.display = "block";
  }
  else
  {
    featureImage.style.display = "none";
  }

  const state = states.find(s => s.STUSPS === currentFeature.get('state'));
  featureData.innerHTML = "<p>" + state.NAME + " | " + currentFeature.get('date') + "</p>";

  var backText = "";
  //console.log("curselection: " + curSelection);
  switch (curSelection)
  {
    case "state":
    case "category":
    case "library":
    case "statelibrary":
      backText = "RESULTS";
      break;
    default:
      backText = "FILTERS";
      break;
  }
  backFromEvent.innerHTML = "&lt; &nbsp;BACK TO " + backText;

  var catOutput = "";
  for (const c of categories) {
    if (c.code === currentFeature.get('category')) {
      featureTitle.style.backgroundColor = "#" + c.color;
      //catOutput += "<img src=\"./markers/" + c.code + "_cat.png\" style=\"display:inline-block; padding-right:5px; height:20px;\"> " + c.title;
      catOutput += "<div style=\"display:flex\"><div><img src=\"./markers/" + c.code + "_cat.png\" style=\"height:2.2vmin;\"></div><div style=\"flex: 1;font-size:1.4vmin; padding-left:10px; \">" + c.title + "</div></div>";
  
      featureData.style.color = '#' + c.color;

      if (currentFeature.get('link') != null && currentFeature.get('link').includes('http'))
      {
        featureLearnMoreStyle.innerHTML = ".cls-1{isolation:isolate;}.cls-2{fill:#" + c.color + ";}.cls-3{fill:#fff2da;}";
        learnMore.style.display = 'inline-block';
        learnMoreLink.href = currentFeature.get('link');
      }
      else
      {
        learnMore.style.display = 'none';
      }
      break;
    }
  }
  for (const c of categories) {
    if (currentFeature.get('subcategories').includes(c.code))
    {
      //catOutput += "<div style=\"margin-top: 5px\"><img src=\"./markers/" + c.code + "_cat.png\" style=\"display:inline-block; padding-right:5px; height:20px;\"> " + c.title + "</div>";
      catOutput += "<div style=\"margin-top: 0.7vmin; display:flex\"><div><img src=\"./markers/" + c.code + "_cat.png\" style=\"height:2.2vmin;\"></div><div style=\"flex: 1;font-size:1.4vmin; padding-left:10px; \">" + c.title + "</div></div>";
  
    }
  }
  featureCategory.innerHTML = catOutput;

  const imgCredit = currentFeature.get('imageCredit') != "" ? "<p style=\"font-size: 1.2vmin; color: #666; margin-top: 5px;\">Image Credit: " + currentFeature.get('imageCredit') + "</p>" : "";

  const featureText = document.getElementById("featureText");
  featureText.innerHTML = "<p style=\"font-size: 1.7vmin\">" + currentFeature.get('description') + "</p>" + imgCredit;

}



function parseBackFromEvent()
{
  var toPanel = "filters";
  console.log("back from event, curselection: " + curSelection);
  switch (curSelection)
  {
    case "state":
      toPanel = "state";
      showState(curSection);
      break;
    case "category":
      toPanel = "category";
      resetMapView();
      break;
    case "library":
    case "statelibrary":
      toPanel = "library";
      showLibrary(curId);
      break;
    case "periods":
    case "videos":
    default:
      toPanel = "filters";
      resetMapView();
      break;
  }

  //console.log("toPanel: " + toPanel);
  togglePanel(toPanel);
}





function togglePanel(current)
{
  const sections = [ "filters", "info", "category", "state", "video", "library" ];
  for (const s of sections) {
    if (s === current) {
      document.getElementById(s).style.display = 'block';
    }
    else {
      document.getElementById(s).style.display = 'none';
    }
  }
}

function toggleFeature(feature, visible)
{
  if (visible)
  {
    feature.setStyle(feature.get('style'));
  }
  else
  {
    feature.setStyle(new Style({}));
  }
}



var panelVisible = true;

const panelToggle = document.getElementById("panelToggle");
panelToggle.addEventListener('click', togglePanelVisibility);

function togglePanelVisibility()
{
  if (panelVisible)
  {
    showHidePanel(false);
  }
  else
  {
    showHidePanel(true);
  }
}

function showHidePanel(show)
{
  //console.log("togglePanelVisibility");
  const mapDiv = document.getElementById("map");
  const panelDiv = document.getElementById("sidepanel");
  if (!show)
  {
    //mapDiv.style.width = '100%';
    panelDiv.style.width = '0';
    panelDiv.style.display = 'none';
    panelToggle.style.left = '0';
    panelVisible = false;
    panelToggle.innerHTML = "&gt;";
  }
  else
  {
    //mapDiv.style.width = 'calc(100% - 400px)';
    panelDiv.style.width = '20vw';
    panelDiv.style.display = 'block';
    panelToggle.style.left = 'clamp(200px, 20vw, 500px)';
    panelVisible = true;
    panelToggle.innerHTML = "&lt;";
  }
}

function compare( a, b ) {
  if ( a.lat > b.lat ){
    return -1;
  }
  if ( a.lat < b.lat ){
    return 1;
  }
  return 0;
}

function getYoutubeCode(url)
{
  let VID_REGEX = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

  return url.match(VID_REGEX)[1];
}


